import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, CardActions, CardContent, CardHeader, Divider, Grid, Typography } from '@mui/material'
import Contact from './Contact'
import AddUserDialog from './AddUserDialog'
import { useSelector } from 'react-redux'
import { useFirestore } from '../../hooks/useFirestore'
import { ACTIVITY_COLLECTION } from '../../_constants/globals'
import { getActivityUsers } from '../../_helpers/firestoreHelper'


const UserCard = ({ sx }) => {
  const selectedActivityId = useSelector(state => state.data.selectedActivityId)
  const activityHooks = useFirestore(ACTIVITY_COLLECTION)
  const dbActivities = activityHooks.getDocs()
  
  const [addUserDialogOpen, setAddUserDialogOpen] = useState(false)
  
  const activity = useMemo(() => dbActivities?.find(a => a.id === selectedActivityId) || {}, [dbActivities, selectedActivityId])
  const users = useMemo(() => getActivityUsers(activity), [activity])
  
  return (
    <Card sx={sx}>
      <CardHeader title='Liste des participants' />
      <CardContent>
        <Grid container>
          <Grid item size={4}>
            <Typography component='div' fontWeight='bold' textAlign='center'>{users?.filter(u => u.role === 'Instructeur').length || 0}</Typography>
            <Typography component='div' variant='caption' textAlign='center'>INSTRUCTEURS</Typography>
          </Grid>
          <Grid item size={4}>
            <Typography component='div' fontWeight='bold' textAlign='center'>{users?.filter(u => ['Organisateur', 'Pilote'].includes(u.role)).length || 0}</Typography>
            <Typography component='div' variant='caption' textAlign='center'>PILOTES</Typography>
          </Grid>
          <Grid item size={4}>
            <Typography component='div' fontWeight='bold' textAlign='center'>{users?.filter(u => ['MEG', 'VD'].includes(u.role)).length || 0}</Typography>
            <Typography component='div' variant='caption' textAlign='center'>INVITÉS</Typography>
          </Grid>
        </Grid>
        <Divider sx={{ my: 2 }} />
        {users?.map(u => <Contact key={u.id} userId={u.id} role={u.role} />)}
      </CardContent>
      <CardActions>
        <Button fullWidth onClick={() => setAddUserDialogOpen(true)}>Ajouter un participant</Button>
      </CardActions>
      {addUserDialogOpen && <AddUserDialog open onClose={() => setAddUserDialogOpen(false)} activityId={selectedActivityId} />}
    </Card>
  )
}

UserCard.propTypes = {
  sx: PropTypes.object,
}

export default UserCard
